// Technical-support contact shown in the support popup, chat window and AI replies
export const SUPPORT_CONTACT = {
  hotline: '024 62750972',
  hotlineTel: '02462750972',
  email: 'info@gbs-jsc.com'
};
